<template>
  <div class="modal-card">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">Aperçu document</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <section class="modal-card-body is-paddingless">
      <form class="columns is-gapless is-column is-minH100">
        <div
          class="column"
          v-if="device === 'desktop'"
          style="flex-basis: auto;">
          <!-- Style pour safari -->
          <iframe
            @load="loading = false"
            :src="link"
            width="100%"
            height="100%"
            style="border: none; min-height: calc(100vh - 150px);">
            <p>Your browser does not support PDFs.
            <a :href="link">Download the PDF</a>.</p>
          </iframe>
        </div>
        <div class="column is-narrow columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small">
          <div
            class="column"
            v-if="canUseBuyerSpace && hasButton"
            :class="[device == 'desktop' ? 'is-4' : 'is-5']">
            <button
              @click="addToAdvDoc(link)"
              class="button is-transform-none is-success is-fullwidth">
              <span>Enregistrer dans l'espace acquéreur</span>
            </button>
          </div>
          <div
            class="column is-margin-left-small"
            :class="[device == 'desktop' ? 'is-4' : 'is-5']">
            <button
              @click="download(link)"
              type="button"
              class="button is-transform-none is-success is-fullwidth">
              <span>Télécharger document au format pdf</span>
            </button>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import { Upload } from '@/mixins'
import { mapState, mapGetters } from 'vuex'
import { concat } from 'lodash'

export default {
  name: 'DocumentPreviewAdf',
  mixins: [Upload],
  props: {
    active: {
      type: Boolean,
      required: true
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(['canUseBuyerSpace']),
    ...mapState(['device', 'currentSale', 'currentAdv']),
    link () {
      return this.params.link
    },
    adf () {
      return this.params.adf
    },
    hasButton () {
      return this.params.hasButton
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    download (file) {
      let link = document.createElement('a')
      link.href = file
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
    },
    async addToAdvDoc (file) {
      let urls = [file]
      try {
        await this.setFusToken()
        let res = await this.$fus.clonedUrlList(urls)
        let hostedFiles = res.data.slice()
        hostedFiles = hostedFiles.map(x => {
          return {
            fus_id: x.id,
            cloudinary_id: x.cloudinary_id,
            cloudinary_version: x.cloudinary_version,
            path: x.path,
            destination: ['display_in_adv', 'buyer_space'],
            filename: `appel_de_fond_etape_${this.adf.name}`,
            display: x.display || true
          }
        })
        let key = 'documents'
        let value = concat(this.currentSale.documents, hostedFiles)
        await this.$store.commit('modifyCurrentSale', { key, value })
        await this.$store.dispatch('updateCurrentSale')
        this.$toasted.global.success('Image ajoutée')
        await this.$api.post(`/reservations/${this.currentAdv.pk}/buyer-space-send-adf`)
        this.loadingImg = false
      } catch (err) {
        console.log(err)
        this.$toasted.global.success('Erreur lors de l\'inclusion des images')
        this.loadingImg = false
      }
    }
  }
}
</script>
